/** Avatar with optional equipped frame: frame = {code, name, color} */
export default function FramedAvatar({ src, initial, frame, size = "w-16 h-16", text = "text-2xl", testid }) {
  const style = frame ? { boxShadow: `0 0 0 4px ${frame.color}, 0 0 22px ${frame.color}88`, border: "2px solid #0B0D14" } : undefined;
  return (
    <div className="relative shrink-0" data-testid={testid} data-frame={frame?.code || ""}>
      <div className={`${size} rounded-full bg-[#FF1E27] overflow-hidden flex items-center justify-center font-display font-black ${text}`} style={style}>
        {src ? <img src={src} alt="avatar" className="w-full h-full object-cover" /> : initial}
      </div>
      {frame && <span className="absolute -bottom-1 left-1/2 -translate-x-1/2 px-1.5 rounded text-[8px] font-mono-rl tracking-widest text-black whitespace-nowrap" style={{ background: frame.color }} data-testid="avatar-frame-label">{frame.name.replace("Cornice ", "").toUpperCase()}</span>}
    </div>
  );
}
